import { ServiceCaseStatus } from "../enum/service-case-status.enum";
import { SortExpression } from "../../../common/model/query-base";


export class ServiceCaseQuery{
  userEmail!: string | undefined;
  ticketId!: string;
  description!: string;
  createdBy!: string;
  affectedPerson!: string;
  from!: string; // ISO string format (e.g., "2025-03-18T07:29:40.111Z")
  to!: string;   // ISO string format (e.g., "2025-03-18T07:29:40.111Z")
  reference!: string;
  status!: ServiceCaseStatus;
  sortExpression?: SortExpression;
}
